import React from 'react';
import styles from './header.module.scss';
import { AttoLogo } from '../../resources/img/atto-logo';
import { useSettings } from '../../hooks/queryHooks';
import { useStepsState } from '../../hooks/zustandHooks';
import { useTranslation } from 'react-i18next';
import { islightColor } from '../../utils/ColorHelper';

const Header = () => {
  const { settings, isSettingsLoading } = useSettings();
  const { t } = useTranslation();
  const { steps, activeStep } = useStepsState();

  const customBgColor = settings?.customColors?.backgroundColor;
  const isLightBackground = customBgColor ? islightColor(customBgColor) : null;

  return (
    <header
      className={`${styles.header} justify-between xl:justify-center ${
        customBgColor && (isLightBackground === true ? 'text-primary-2' : 'text-white')
      }`}
    >
      {settings?.directIDLogoUrl ? (
        <img src={settings.directIDLogoUrl} alt="Atto Logo" className="h-10 sm:h-[50px] max-w-56" />
      ) : (
        <AttoLogo className="w-20 h-8 lg:h-[50px] lg:w-[154px] sm:w-[116px] sm:h-[36px]" />
      )}
      {!isSettingsLoading && activeStep && (
        <h2 className="uppercase text-lg font-semi-bold block xl:hidden">
          {t(activeStep?.title || '')} {t('of')} {steps.length.toLocaleString(navigator.language)}
        </h2>
      )}
    </header>
  );
};

export default Header;
